import React, { Component } from 'react';
import { Card, Col, message, Row } from 'antd';

import { queryFinanceBooksPayStatistics } from '@api/finance/finance';
import util from '@util';

class FinanceCapitalDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      statistics: {},
    };
  }

  componentWillMount() {}

  componentDidMount() {
    this.loadStatistics();
  }

  componentWillReceiveProps(nextProps) {
    const { reStatistic } = nextProps;
    if (reStatistic) {
      this.loadStatistics();
    }
  }

  /**
   * 获取账号统计
   */
  loadStatistics = uuid => {
    const { handlerFlag } = this.props;
    queryFinanceBooksPayStatistics(uuid).then(res => {
      if (res.statusCode === 200) {
        this.setState({ statistics: res.data });
        handlerFlag();
      } else {
        message.error(res.message);
      }
    });
  };

  render() {
    const { statistics } = this.state;
    return (
      <Card className="description">
        <Row type="flex" justify="space-around" align="middle">
          <Col span={6}>
            <p>
              <span className="title">走账支出:</span> <span>{statistics.expenditure}</span>
            </p>
          </Col>
          <Col span={6}>
            <p>
              <span className="title">走账收入:</span>
              <span>{util.numberFormat(statistics.income, 2, '.', ',')}</span>
            </p>
          </Col>
          <Col span={6}>
            <p>
              <span className="title">总计:</span> <span>{statistics.sum}</span>元
            </p>
          </Col>
          <Col span={6}>
            <p>
              <span className="title">总数:</span> <span>{statistics.count}</span>笔
            </p>
          </Col>
        </Row>
      </Card>
    );
  }
}
export default FinanceCapitalDetail;



// WEBPACK FOOTER //
// ./src/components/finance/capital/detail/CardPayStatistic.js